async function configureClientAnalytics(opts) {
  const { analytics, replicantClientPromise } = opts;
  await replicantClientPromise.then((replicant) => {
    replicant.extras.setActionAnalyticsCallback((events) => {
      events.forEach(({ eventType, eventProperties, userProperties }) => {
        analytics.setUserProperties(userProperties);
        analytics.pushEvent(eventType, eventProperties);
      });
    });
  });
}
export {
  configureClientAnalytics
};
